import React from 'react';
import { SaleData } from '../../../types';

interface VehicleFormProps {
    saleData: SaleData;
    onPlateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onCardChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onNext: (e: React.FormEvent<HTMLFormElement>) => void;
    onClear: () => void;
    getFormattedCard: () => string;
}

export const VehicleForm: React.FC<VehicleFormProps> = ({
    saleData,
    onPlateChange,
    onCardChange,
    onNext,
    onClear,
    getFormattedCard
}) => {
    return (
        <form className="terminal-form" onSubmit={onNext} autoComplete="off">
            <div className="form-row">
                <div className="form-group plate-group">
                    <label htmlFor="vehiclePlate">Placa do Veículo:</label>
                    <input
                        type="text"
                        id="vehiclePlate"
                        value={saleData.vehiclePlate}
                        onChange={onPlateChange}
                        placeholder="ABC1234"
                        maxLength={7}
                        disabled={saleData.vehicleCard.length > 0}
                        autoComplete="off"
                        data-lpignore="true"
                        data-form-type="other"
                    />
                </div>

                <div className="form-or">
                    <span>OU</span>
                </div>

                <div className="form-group card-group">
                    <label htmlFor="vehicleCard">Cartão do Veículo:</label>
                    <input
                        type="text"
                        id="vehicleCard"
                        value={getFormattedCard()}
                        onChange={onCardChange}
                        placeholder="1234 5678 9012 3456"
                        maxLength={19}
                        disabled={saleData.vehiclePlate.length > 0}
                        autoComplete="off"
                        data-lpignore="true"
                        data-form-type="other"
                    />
                </div>
            </div>

            <div className="form-actions">
                <button type="button" className="clear-btn" onClick={onClear} title="Limpar Terminal">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 6H5H21M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M14 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
                <button type="submit" className="submit-btn" disabled={!saleData.showFirstData}>
                    Próximo
                </button>
            </div>
        </form>
    );
};
